var _title, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    xmlSpace: "preserve",
    width: 12.394088684761865,
    height: 10.423645260952554,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    className: ""
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    className: "",
    transform: "rotate(89.9362564086914 6.506280899047852,6.437771797180176) ",
    fillOpacity: 1,
    fill: "#112240"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8604728444284184,9.849874726777955 V3.0031833984908314 c0,-0.7938192844390878 0.772320666909218,-1.2899563372135163 1.3629188239574448,-0.8930466949939738 l5.451675295829773,3.4233456641435627 c0.636028784513475,0.3969096422195443 0.636028784513475,1.438797453045845 0,1.8357070952653887 l-5.451675295829773,3.4233456641435627 C3.632793511337635,11.139831063991473 2.8604728444284184,10.643694011217043 2.8604728444284184,9.849874726777955 z",
    id: "play",
    fill: "#112240"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchArrow);
export default __webpack_public_path__ + "static/media/search_arrow.8ef0e94d.svg";
export { ForwardRef as ReactComponent };